package com.yogaaicoach.pages.auth

import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.p
import web.cssom.ClassName

internal external interface ResetPasswordConfirmationPageProps : Props {
    var email: String
    var onGoToLogin: () -> Unit
}

// Pixel-matched against ResetPasswordConfirmationScreen.kt — a plain centered text block.
internal val ResetPasswordConfirmationPage = FC<ResetPasswordConfirmationPageProps> { props ->
    div {
        className = ClassName("auth-message-page")

        p { className = ClassName("auth-message-text"); +"We've sent a password reset link to your email address:" }
        p { className = ClassName("auth-message-text auth-message-bold"); +props.email }

        button {
            className = ClassName("primary-button")
            +"Go to Login"
            onClick = { props.onGoToLogin() }
        }
    }
}
